<template>

  <group-container v-if="!shouldHide" :title="element.label">

    <el-tabs v-if="hasList" v-model="activeTab" style="margin-top: 20px" @tab-change="handleTabChange">
      <el-tab-pane v-for="(item,index) in element.attrs.list" :key="index"
                   :name="String(index)" :label="tabLabel(item,index)" lazy>
        <el-table v-if="states[index] && states[index].form" :data="states[index].list" tooltip-effect="dark"
                  style="width: 100%;border-radius: 6px" row-key="id"
                  :header-cell-style="{color:'#344262','background-color':'#F2F7F9'}" :max-height="element.attrs.height"
                  element-loading-background="rgb(255,255,255,0.4)" v-loading="states[index].loading" empty-text="   "
                  border stripe>
          <el-table-column v-if="item.showTitle" label="数据标题" fixed="left" width="200">
            <template #default="scope">
              <span class="data-title">{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column
              v-for="column in states[index].targetColumns.filter(filter=>item.showColumns.some(some=>some.id===filter.id))"
              :key="column.id" :label="column.label.toUpperCase()" align="center">
            <template v-slot:default="scope">
              <column-show :key="column.id+new Date()" :column="column"
                           :value="formStore.getValue(scope.row,column.id)" container="table"
                           :data="scope.row"></column-show>
            </template>
          </el-table-column>
          <el-table-column></el-table-column>
        </el-table>
        <div v-else v-loading="states[index] && states[index].loading" style="min-height: 120px"></div>
      </el-tab-pane>
    </el-tabs>


  </group-container>


</template>

<script>

import {mapStores} from "pinia";
import {useFlowStore} from "@/stores/flow";
import {useFormStore} from "@/stores/form";
import {useMenuStore} from "@/stores/menu";
import GroupContainer from "@/components/common/groupContainer.vue";
import {debounce} from "lodash";


export default {
  components: {GroupContainer},
  props: {
    element: {
      type: Object,
      default: () => {
      }
    },
    context: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      data: null,
      activeTab: '0',
      states: [],          // 与 element.attrs.list 一一对应，保存每个列表的运行态
      formNameCache: {},   // formId -> 表单名称（用于 tab 标题）
      debouncedHandler: debounce(() => {
        this.queryLoadedLists();
      }, 1),
    }
  },
  computed: {
    ...mapStores(useFlowStore, useFormStore, useMenuStore),
    hasList() {
      return this.element.attrs && Array.isArray(this.element.attrs.list) && this.element.attrs.list.length > 0;
    },
    /** 新增状态：当前数据还没有 id */
    isCreate() {
      return !(this.context && this.context.data && this.context.data.id);
    },
    hideOnCreate() {
      return Boolean(this.element.attrs && this.element.attrs.hideOnCreate);
    },
    /** 新增状态下隐藏：不展示、不加载数据 */
    shouldHide() {
      return this.hideOnCreate && this.isCreate;
    }
  },
  created() {
    // 新增状态下隐藏：不初始化、不加载数据
    if (this.shouldHide) return;

    this.data = this.context.data;
    this.initStates();
    this.initWatch();
    this.loadFormNames();
    this.ensureLoaded(0);
  },
  methods: {
    initStates() {
      this.states = (this.element.attrs.list || []).map(() => {
        return {
          form: null,
          targetColumns: [],
          list: [],
          loading: false,
          loaded: false,
          page: {
            currentPage: 1,
            pageSize: 10,
            count: 0,
          },
        }
      });
    },
    tabLabel(item, index) {
      return this.formNameCache[item.value] || `列表${index + 1}`;
    },
    loadFormNames() {
      (this.element.attrs.list || []).forEach(item => {
        if (item.value && !this.formNameCache[item.value]) {
          this.menuStore.findById(item.value).then(res => {
            if (res && res.data) {
              this.formNameCache[item.value] = res.data.name;
            }
          });
        }
      });
    },
    handleTabChange(name) {
      this.ensureLoaded(Number(name));
    },
    ensureLoaded(index) {
      let item = this.element.attrs.list[index];
      let state = this.states[index];
      if (!item || !state) return;

      if (!item.value) {
        state.loaded = true;
        return;
      }

      if (!state.form) {
        this.menuStore.findById(item.value).then(res => {
          state.form = res.data;
          state.targetColumns = this.formStore.columns(state.form);
          this.queryList(index);
        });
      } else if (!state.loaded) {
        this.queryList(index);
      }
    },
    initWatch() {
      if (!this.data) return;

      let script = (this.element.attrs.list || [])
          .flatMap(item => (item.queryFilter || [])
              .filter(filter => filter.valueType === 'dynamic')
              .map(mapper => mapper.script.value))
          .join("|");

      let columns = this.formStore.columnsFlatMap(this.context.form);

      Object.keys(this.data)
          .filter(filter => filter !== this.element.id)
          .filter(filter => columns.some(column => column.id === filter))
          .filter(filter => script.includes(filter)).forEach(key => {

        this.$watch(`data.${key}`, this.debouncedHandler, {
          deep: true,
          immediate: false
        });
      });

    },
    queryLoadedLists() {
      this.states.forEach((state, index) => {
        if (state.loaded) {
          this.queryList(index);
        }
      });
    },
    queryList(index) {
      let item = this.element.attrs.list[index];
      let state = this.states[index];
      if (!item || !state || !item.value) return;

      state.loading = true;

      this.formStore.list(item.value, state.page.currentPage, state.page.pageSize, "[]", "[]", "", {
        //根据当”前行数据“动态筛选关联表单可选项
        dataJson: JSON.stringify(this.data),
        currentFormId: this.context.form.id,
        currentElementId: this.element.id
      }).then(res => {
        if (res.code === 200) {
          state.list = res.data.list;
          state.page = res.data.page;
        }

        state.loading = false;
        state.loaded = true;
      })

    }
  }
}

</script>

<style scoped lang="scss">

</style>
